import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  FlashcardData,
  CREATE_CARD_PREFIX,
  DELETE_CARD_PREFIX,
  UPDATE_CARD_PREFIX,
} from "./types";
import { NormalizedEntity } from "../types";
import { normalize } from "normalizr";
import { CardSchema } from "../resources";
import { exceptionHandler } from "../utils";
import OverleafApi from "../../../../../../../services/overleaf";
import {
  convertFullUrlToContentUrl,
  MediaTypes,
} from "../../../../../../../services/overleaf/utils";

const overleafApi = new OverleafApi();

const normalizeCard = ({ card }) => {
  return normalize(card, CardSchema);
};

export const createFlashcard = createAsyncThunk(
  CREATE_CARD_PREFIX,
  async (
    data: FlashcardData,
    { rejectWithValue }
  ): Promise<NormalizedEntity<any>> => {
    const instance = await overleafApi.getInstance();
    return instance.Cards.create(data.deckUUID, {
      front: {
        ...data.front,
        content:
          data.front.type === MediaTypes.IMAGE
            ? convertFullUrlToContentUrl(data.front.content)
            : data.front.content,
      },
      back: {
        ...data.back,
        content:
          data.back.type === MediaTypes.IMAGE
            ? convertFullUrlToContentUrl(data.back.content)
            : data.back.content,
      },
    }).then(normalizeCard, exceptionHandler.bind(this, rejectWithValue));
  }
);

export const updateFlashcard = createAsyncThunk(
  UPDATE_CARD_PREFIX,
  async (data: any, { rejectWithValue }): Promise<NormalizedEntity<any>> => {
    const instance = await overleafApi.getInstance();
    return await instance.Cards.update(data.deckUUID, data.uuid, {
      front: data.front,
      back: data.back,
    }).then(normalizeCard, exceptionHandler.bind(this, rejectWithValue));
  }
);

export const deleteFlashcard = createAsyncThunk(
  DELETE_CARD_PREFIX,
  async (
    {
      deckUUID,
      id,
    }: {
      deckUUID: string | undefined;
      id: string;
    },
    { rejectWithValue }
  ): Promise<NormalizedEntity<any>> => {
    if (!id || !deckUUID) {
      return {};
    }
    const instance = await overleafApi.getInstance();
    return instance.Cards.delete(deckUUID, id).catch(
      exceptionHandler.bind(this, rejectWithValue)
    );
  }
);
